import { StaticDataItem } from "../../models/types/statistic";
import { useLookupParameter } from "../../utils/get-lookup";
import dayjs from "dayjs";

const StatisticTable = ({ staticData, loading }: { staticData: StaticDataItem[]; loading?: boolean }) => {
    const { lookupParameter } = useLookupParameter();
    const columns = Array.from(
        new Set(
            staticData?.flatMap((item: any) =>
                Array.isArray(item.data) ? item.data.map((d: any) => {
                    return d.parameterId;
                }) : []
            )
        )
    );

    return (
        <table className="h-full overflow-y-auto w-full relative overflow-x-auto statistic-table">
            <thead className="">
                <tr>
                    <th rowSpan={2}>STT</th>
                    <th rowSpan={2}>Thời gian</th>
                    <th colSpan={columns.length} rowSpan={1}>Thông số</th>
                </tr>
                <tr>
                    {columns.map((column, idx) => {
                        const parameter = lookupParameter.find((p: any) => p.id === column);
                        return (
                            <th key={idx}>{`${parameter?.name} (${parameter?.unitName || '-'})`}</th>
                        )
                    })}
                </tr>
            </thead>
            <tbody>
                {loading ? (
                    <tr>
                        <td colSpan={columns.length + 2} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                            </div>
                        </td>
                    </tr>
                ) : staticData?.length === 0 ? (
                    <tr>
                        <td colSpan={columns.length + 2} className="text-center py-4">
                            <div className="flex items-center justify-center">
                                <div className="text-gray-500">Chưa có dữ liệu</div>
                            </div>
                        </td>
                    </tr>
                ) : (
                    staticData?.map((item: any, idx: number) => {
                        // Map parameterName -> value
                        const valueMap: Record<string, number> = {};
                        const statusMap: Record<string, number> = {};
                        if (Array.isArray(item.data)) {
                            item.data.forEach((d: any) => {
                                valueMap[d.parameterId] = d.value;
                                statusMap[d.parameterId] = d.status;
                            });
                        }
                        return (
                            <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td>{item.waterMonitoringTime ? dayjs(item.waterMonitoringTime).format('DD/MM/YYYY HH:mm') : "-"}</td>
                                {columns.map((param: any) => (
                                    <td key={param} className={statusMap[param] === 2 ? "abnormal" : ""}>
                                        {valueMap[param] ?? "-"}
                                    </td>
                                ))}
                            </tr>
                        );
                    })
                )}
            </tbody>
        </table>
    )
}

export default StatisticTable;
